import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Modal, Row, Col, Table } from "antd";
import { CustomButton, CustomText, CustomTextArea, FormSelect, useCustomToast } from "../../../../../components";
import ModalAssessment from "./ModalAssesment";
import { InventoryViewAPI } from "../../../api/inventoryViewAPI";
import { UploadedFile } from "../../../../../utils";
import { useNavigate } from "react-router-dom";

interface IModalManageItem {
    isModalManageItem: boolean;
    setIsModalManageItem: (value: boolean) => void;
    selectedItem: any;
    onSuccess?: () => void;
    onClose: () => void;
    onSave: (itemUpdate: { id: number; status_id: number; observations: string }) => void;
}

export interface EvaluationItem {
    key: number;
    rol: string;
    documento: string;
    codigo: number;
    listaPredefinida: string;
    caracteristica: string;
    descripcionRevision: string;
    tecnico: string;
    estado: string;
    delivery_deadline?: string;
    observations: string | null;
    status_id?: string;
}

interface PredefinedList {
    id: number;
    name: string;
    predefined_list_aspects: {
        id: number;
        aspect: string;
        description: string;
    }[];
}

const ModalManageItem: React.FC<IModalManageItem> = ({
    isModalManageItem,
    setIsModalManageItem,
    selectedItem,
    onClose,
    onSave
}) => {
    const [listasEstablecidas, setListasEstablecidas] = useState<EvaluationItem[]>([]);
    const [isModalEvaluarOpen, setIsModalEvaluarOpen] = useState(false);
    const [selectedEvaluation, setSelectedEvaluation] = useState<EvaluationItem | null>(null);
    const [predefinedList, setPredefined] = useState<PredefinedList[]>([]);
   const [files, setFiles] = React.useState<UploadedFile[]>();
   const { showToast } = useCustomToast();
    const formik = useFormik({
        initialValues: {
            estadoElemento: "",
            descripcionRevision: "",
        },
        onSubmit: (values) => {
            if (!selectedItem?.id) return;
          
            const itemUpdate = {
              id: selectedItem.id,
              status_id: Number(values.estadoElemento),
              observations: values.descripcionRevision,
            };
            onSave(itemUpdate);
          
            onClose();
          },
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const assetClassId = selectedItem?.asset_class_id ? selectedItem.asset_class_id.toString() : '';

                const data = await InventoryViewAPI.fetchParameters(
                    ['predefined_list'],
                    { asset_class_id: assetClassId }
                );
                if (data) setPredefined(data.predefined_list || []);
            } catch (error) {
                console.error('Error fetching parameters:', error);
            }
        };
        fetchData();
    }, [selectedItem]);


    useEffect(() => {
        if (selectedItem?.evaluations) {
            const evaluations: EvaluationItem[] = selectedItem.evaluations.map((evaluation: any) => ({
                key: evaluation.id,
                codigo: evaluation.id,
                listaPredefinida: evaluation.predefined_list,
                caracteristica: evaluation.predefined_list_aspect,
                descripcionRevision: evaluation.predefined_list_description,
                tecnico: evaluation.user,
                estado: evaluation.status,
                rol: evaluation.user_role,
                documento: evaluation.user_document,
                observations: evaluation.observations || "",
                delivery_deadline       : evaluation.delivery_deadline || "",
            }));
            setListasEstablecidas(evaluations);
        } else {
            setListasEstablecidas([]);
        }
    }, [selectedItem]);

    const status = [
        { id: 15, status: 'Recibido' },
        { id: 10, status: 'Rechazado' }
      ];
      

    const navigate = useNavigate();
    const handleSuccess = () => {
        navigate("/inventoryView"); 
    };
    

    return (
        <>
            <Modal
                width='95vw'
                title={`Detalle traslados entre funcionarios - ${selectedItem?.ticket || 'N/A'}`}
                open={isModalManageItem}
                onCancel={() => setIsModalManageItem(false)}
                footer={[
                    <CustomButton key="cancel" label="Cancelar" onClick={() => setIsModalManageItem(false)} buttonType="secondary" />,
                    <CustomButton key="save" label="Guardar" onClick={() => formik.handleSubmit()} />,
                ]}
            >
                <form onSubmit={formik.handleSubmit}>
                <br></br>
                <CustomText text="Activo principal" strong fontSize="small" />
                    <Table
                        dataSource={selectedItem ? [selectedItem] : []}
                        columns={[
                            { title: 'Item', dataIndex: 'id', key: 'plate_code' },
                            { title: 'Código/placa', dataIndex: 'plate_code', key: 'plate_code' },
                            { title: 'Descripción elemento', dataIndex: 'asset', key: 'asset' },
                            {
                                title: 'Clase de activo',
                                dataIndex: 'class',
                                key: 'class',
                                render: (_: any, record: any) => `${record.class_code} - ${record.class}`,
                              },
                              
                              {
                                title: 'Artículo',
                                key: 'item',
                                render: (_: any, record: any) => `${record.item_code} - ${record.item}`,
                              },
                              {
                                title: 'Adiciones',
                                dataIndex: 'assets_count',
                                key: 'assets_count',
                              },
                            { title: 'Estado del bien', dataIndex: 'asset_status', key: 'asset_status' },
                        ]}
                        pagination={false}
                    />
<br></br>
<CustomText text="Adiciones" strong fontSize="small" />

<Table
                        dataSource={selectedItem.assets}
                        columns={[
                            { title: 'Item', key: 'index',
                                render: (_: any, __: any, index: number) => index + 1 },
                            { title: 'Código/placa', dataIndex: 'plate_code', key: 'plate_code' },
                            { title: 'Descripción elemento', dataIndex: 'description', key: 'description' },
                            {
                                title: 'Clase de activo',
                                dataIndex: 'class',
                                key: 'class',
                                render: (_: any, record: any) => `${record.class_code} - ${record.class}`,
                              },
                              
                              {
                                title: 'Artículo',
                                key: 'item',
                                render: (_: any, record: any) => `${record.item_code} - ${record.item}`,
                              },
                              { title: 'Estado del bien', dataIndex: 'asset_status', key: 'asset_status' },
                        ]}
                        pagination={false}
                    />

                    <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                        <Col xs={24} sm={12}>
                            <FormSelect
                                label="Estado del elemento"
                                name="estadoElemento"
                                placeholder="Seleccione"
                                value={formik.values.estadoElemento}
                                onChange={(value) => formik.setFieldValue("estadoElemento", value)}
                                onBlur={() => formik.setFieldTouched("estadoElemento", true)}
                                options={status.map((x) => ({
                                    name: x.status,
                                    id: x.id.toString(),
                                }))}
                            />
                        </Col>
                    </Row>
                    <Row>
        <Col xs={24}>
          <CustomTextArea
            label="Observaciones"
            name="descripcionRevision"
            placeholder="Observaciones"
            value={formik.values.descripcionRevision}
            error={formik.errors.descripcionRevision}
            touched={formik.touched.descripcionRevision}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>

                
                </form>
            </Modal>
            {selectedEvaluation && (
                <ModalAssessment
                    isOpen={isModalEvaluarOpen}
                    onClose={() => setIsModalEvaluarOpen(false)}
                    evaluation={selectedEvaluation}
                    onFiles={setFiles}
                    files={files}
                    onSuccess={handleSuccess}
                />
            )}

        </>
    );
};

export default ModalManageItem;
